// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules_dev/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h1[data-v-1d495002]{margin-bottom:20px}main[data-v-1d495002]{padding:20px}article[data-v-1d495002]{text-align:justify}.underline[data-v-1d495002]{text-decoration:underline}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
